import React from 'react';
import { Flex, Table, TableBody, TableCell, TableRow } from '@aws-amplify/ui-react';
import { TableHead } from '@aws-amplify/ui-react';
import './ModelPerformanceTable.css';

const ModelPerformanceTable = () => {
  return (
    <Flex direction="column">
      <Table variation="bordered" className="model-performance-table">
        <TableHead>
          <TableRow>
            <TableCell as="th">Name</TableCell>
            <TableCell as="th">Size</TableCell>
            <TableCell as="th">Location</TableCell>
            <TableCell as="th">Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
            <TableCell>Bordered</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Flex>
  )
}

export default ModelPerformanceTable;